import React, { useState, useEffect } from 'react';
import api from '../../Services/api';
import TableCompany from '../../Components/TableCompany';
import { useAblContext } from '../../Hooks/useAblContext';
import Modal from 'react-modal';
import DocumentReader from '../../Components/DocumentReader';
import { CSVLink } from 'react-csv';
import { getTime, format } from 'date-fns'
import ProdutoraDetails from '../../Components/ProdutoraDetails';

const loadingStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width: '773',
    height: '550',
  }
};


export default function FilmProductionCompany() {
  const [company, setCompany] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  const [selectedCompany, setSelectedCompany] = useState({});
  const [selectedLaunchType, setSelectedLaunchType] = useState({});
  const [showModalCompany, setShowModalCompany] = useState(false);

  const abl = useAblContext();
  const requestCompany = async () => {
    api.get('/company', { headers: { authorization: abl.token }}).then(response => {
      const companies = response.data;

      const sorted = companies.sort((a: any,b:any ) => 0 - (a.company.createdAt > b.company.createdAt ? 1 : -1));
      setCompany(sorted);

      const csv = response.data.map((value: any) => (
        {
          TituloFile: value.company.movieTitle,
          NomeProdutora: value.company.producerName,
          NomeProdutorResponsavel: value.company.responsibleProducerName,
          Telefone: value.company.phone,
          RegistroAncine: value.company.ancineRegister,
          CpbAncine: value.company.cpbAncine,
          EmailProdutora: value.company.email,
          CriadoEm: format(new Date(value.company.createdAt), 'dd/MM/yyyy HH:mm'),//format(new Date(value.company.createdAt), 'dd/MM/yyyy HH:mm'),
          Aprovado: value.company.enabled? 'SIM' : 'NAO',
          DataDoLancamento: value.company.launchDate ? format(new Date(value.company.launchDate.toString().replace('Z', '')), 'dd/MM/yyyy') : '-/-'
        }
      ))
    setCsvData(csv);
      setShowLoading(false);
    }).catch(err => {
        console.log(err);
      setShowLoading(false);
    });
  }

  useEffect(() => {
    (
      async () => {
        await requestCompany()
      }
    )();
  }, [])

  const handleDeleteCompany = async (id: string, index: number) => {
    try{
      const response = await api.delete(`/company/${id}`, { headers: { authorization: abl.token }});
      const deleted = response.data;

      if(deleted){
        await requestCompany();
      }
    } catch(err) {
      console.log('Houve um erro ao processar a solicitação.');
    }
  }

  const handleApproveCompany = async (id: string, index: number) => {
    try{
      setShowLoading(true);
      const response = await api.patch(`/company/${id}/approve`, null, { headers: { authorization: abl.token }})
      const enabled = response.data;

      if(enabled){
        await requestCompany();
      }
    } catch(err) {
      setShowLoading(false);
      console.log('Houve um erro ao processar a solicitação.');
    }
  }


  const handleOnCloseModal = () => {
    setShowModal(false);
  }

  const handleSetDocument = (documents: any) => {
    setDocuments(documents);
    setShowModal(true);
  }

  const handleOnCloseModalCompany = () => {
    setShowModalCompany(false);
  }

  const handleViewModalCompany = (documents: any) => {
    setSelectedLaunchType(documents.launchType);
    setSelectedCompany(documents.company);
    setShowModalCompany(true);
  }

  return(
  <>
    <Modal
      isOpen={showLoading}
      style={loadingStyles}
      contentLabel="Adicionar usuário"
    >
      <img src="img/loading.gif" alt="this slowpoke moves"  width={250}/>
    </Modal>
    <ProdutoraDetails show={showModalCompany} onClose={handleOnCloseModalCompany} launchType={selectedLaunchType} company={selectedCompany} />
      <DocumentReader show={showModal} onClose={handleOnCloseModal} files={documents} />
    <div className="container">
      <div className="row text-center">
        <h3>PRODUTORAS CADASTRADAS</h3>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
            {abl.roles === 'admin' && <CSVLink className="btn btn-dark" data={csvData} filename={`Produtoras-${getTime(new Date())}.csv`} separator=";">Export CSV</CSVLink>}
              <TableCompany
                    values={company}
                    onApproveCompany={(id: string, index: number) => handleApproveCompany(id, index)}
                    onDeleteCompany={(id: string, index: number) => handleDeleteCompany(id, index)}
                    onViewDocumentPress={(documents: any ) => handleSetDocument(documents)}
                    onViewModalCompany={(documents: any ) => handleViewModalCompany(documents)}
                    roles={abl.roles}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>)
}
